import ninegrid from "../index.js";

export class ngImport
{
	#owner;
	
	constructor (owner) {
		//super();
		
		this.#owner = owner;
	};
	
	importExcel = () => {
		this.#openFileDialog();
	};
	
	#openFileDialog = () => {
		if (!this.input) {
			this.input = document.createElement('input');
			this.input.type = 'file';
			this.input.onchange = this.#fileSelectedHandler;
		}
		
		this.input.click();
	};
	
	#fileSelectedHandler = (e) => {
	    var files = e.target.files;
	    if (files.length < 1) {
	        alert('select a file...');
	        return;
	    }
	    var file = files[0];
	    var reader = new FileReader();
	    
	    reader.onload = this.#fileLoadedHandler;
	    reader.readAsDataURL(file);
	    reader.onloadend = this.#fileLoadEndHandler;
	}

	#fileLoadedHandler  = e => {
		
	    var match = /^data:(.*);base64,(.*)$/.exec(e.target.result);
	    if (match == null) {
	        throw 'Could not parse result'; // should not happen
	    }
	    
	    var mimeType = match[1];
	    var content = match[2];
	    //alert(mimeType);
	    //alert(content);
	    
	    
	    //var fileReader = new FileReader();

	}
	
	#fileLoadEndHandler = (e) => {
 
		//var arrayBuffer = fileReader.result;
    	var arrayBuffer = e.target.result;

    	const workbook = new ExcelJS.Workbook();
    	
		workbook.xlsx.load(arrayBuffer).then(() => {
			
			workbook.worksheets.forEach((sheet) => {
				sheet.eachRow((row,rowNumber) => {
					
					if (rowNumber % 10 == 0) console.log(rowNumber);
				});
			});
		});
	}
}
